const isProd = process.env.NODE_ENV === 'production';
export default {
    ROOT_PATH: isProd ? '/' : '/portal/'
}